<template>
    <a-card>
        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="2">
                <a-icon type="bar-chart" />
            </a-col>
            <a-col :flex="3" justify="center">
                <p>Ordered by</p>
            </a-col> 
        </a-row>

        <a-row type="flex" justify="start" class="icons-list">
            <a-col :flex="3" justify="center">
                <a-icon type="appstore" />
                <h3>{{ orderedByWebApp }}</h3>
            </a-col>
            <a-col :flex="3" justify="center">
                <a-icon type="phone" />
                <h3>{{ orderedByPhone }}</h3>
            </a-col> 
        </a-row>
    </a-card> 
</template>

<script>
export default {
    props : {
        orderedByWebApp : Number,
        orderedByPhone : Number
    },
    computed : {
        
    },
    data () {
        return {
            marks : {
                1 : '1',
                5 : '5',
                10 : '10',
                15 : {
                    style: {
                        color: '#f50',
                    },
                    label: 15,
                }
            },
            currentCapacity : this.capacity
        }
    },
    methods : {
        handleChanged(e) {
            this.$emit('changed', this.currentCapacity );
        }
    },

    watch: {
        capacity : {
            handler(newValue) {
                this.currentCapacity = newValue;
            },
            flush: 'post'
            
        }
    }
}
</script>

<style scoped>
.icons-list >>> .anticon {
  margin-right: 6px;
  font-size: 24px;
}
</style>
